/**
 * Helper utility functions for the ExperienceSalesFooter component
 */

/**
 * Determines the button text based on the current flow and selection state
 */
export const getButtonText = (
  isExchangeFlow: boolean,
  hasSelection: boolean,
  isPrechargeFlow: boolean
): string => {
  if (isPrechargeFlow) {
    return "Lock in this price";
  }

  if (isExchangeFlow) {
    return hasSelection ? "Confirm Exchange" : "Select Tickets";
  }

  return hasSelection ? "Buy Now" : "Select";
};

export const reservationStickyFooter = (organizationId?: string): boolean => {
  // Orgs that do not want the sticky "Buy Now" footer
  return ![
    // Northern Bass
    "9c46120b-ba52-4fae-b6ac-1d93ba101ae2",
    // USA Demo
    "9c19d2b1-4896-4689-9e6c-9e32c8c942d2",
  ].includes(organizationId);
};
